/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
// baki

import React, { useState, useRef, useEffect, useContext } from 'react';
import moment from 'moment';
import { Button, Input, InputGroup, InputGroupAddon, Badge, Collapse } from 'reactstrap';
// import Picker, { SKIN_TONE_MEDIUM_LIGHT } from 'emoji-picker-react';
import { EmojiButton } from '@joeattardi/emoji-button';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import AuthService from '../../services/AuthService';
import ChatService from '../../services/ChatService';
import ProviderService from '../../services/ProviderService';

// local imports
import UserNotApproved from './UserNotApproved';
import notificationSound from '../../assets/notification.mp3';
import './ProviderChat.css';

// import TwilioChat from 'twilio-chat';
import { Client as ConversationsClient } from '@twilio/conversations';

import searchIcon from "../../assets/search.png";
import s1 from "../../assets/Search1.png";
import send from "../../assets/send.png";
import note from "../../assets/note.png";

// variables
let primaryClient = { user: {} };
let selectedConversationPage = null;
let copyMessages = [];
let currentSearchResult = null;
let currentSearchPage = 0;
let searchResult = [];
let pageSize = 30;
let providerId = '';

const ProviderChat = props => {

    // variables
    let timeout = 0;
    let audio = new Audio(notificationSound);
    let counter = 0;
    let doubleClickCounter = 0;

    // constants
    const defaultProfile = "data:image/png;base64,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";

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);
    const { user, setUser, userApprovalStatus } = useContext(AuthContext);

    // states
    const [connectionLoading, setConnectionLoading] = useState(true);
    const [statusString, setStatusString] = useState("");
    const [conversations, setConversations] = useState([]);
    const [participants, setParticipants] = useState({ primary: { lastReadMessageIndex: 0, identity: "", friendlyName: "", isOnline: false, attributes: { email: "", role: "" } }, secondary: { identity: "", friendlyName: "", isOnline: false, attributes: { email: "", role: "" } } });
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [updateSelectedConversation, setUpdateSelectedConversation] = useState(true);
    const [newNote, setNewNote] = useState({ messageId: '', content: '' });
    const [conversationNotes, setConversationNotes] = useState([
        {
            content: 'This is a sample note1'
        },
        {
            content: 'This is a sample note2m which a longer note than the note1 shown above'
        }
    ]);
    // const [selectedConversationPage, setSelectedConversationPage] = useState(null); //
    const [isShowMoreLoading, setIsShowMoreLoading] = useState(false);
    const [showChatScrollDown, setShowChatScrollDown] = useState(false);
    const [messages, setMessages] = useState([]);
    const [isTyping, setIsTyping] = useState({ status: false, identity: "" });
    const [message, setMessage] = useState("");
    const [showNewMessageLine, setShowNewMessageLine] = useState(false);
    const [selectedConversationMessageStatus, setSelectedConversationMessageStatus] = useState({ lastMessage: null });
    const [search, setSearch] = useState({ status: false, value: "" });
    const [notifications, setNotifications] = useState({ newChatMessage: [] });

    const [toggleTopMenu, setToggleTopMenu] = useState(false);
    const [toggleLeftMenu, setToggleLeftMenu] = useState(true);
    const [toggleRightMenu, setToggleRightMenu] = useState(false);
    const [toggleProfileMenu, setToggleProfileMenu] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        document.getElementById("root").classList.value = "";
        document.getElementById("root").firstElementChild.firstElementChild.classList.value = "firstChildDiv";
        document.getElementById("root").firstElementChild.classList.value = "firstChildDiv";
        window.addEventListener('resize', getHeights);

        getUser();

        // getSubscriptionDetails();

        // getNotifications();

        // toggleSidebar();

        return () => {
            // console.log("leaving", selectedConversation, ",,,", statusString);
            leaveConversation();
            window.removeEventListener('resize', getHeights);
            document.getElementById("root").classList.value = "container container-fluid";
            document.getElementById("root").firstElementChild.firstElementChild.classList.value = "";
            document.getElementById("root").firstElementChild.classList.value = "";
        };
    }, [])

    useEffect(() => {
        if (
            (toggleLeftMenu && toggleRightMenu) ||
            (toggleLeftMenu && toggleProfileMenu)
        ) {
            document.getElementById("mainContainer").classList = "col-md-6 col-12";
        } else {
            document.getElementById("mainContainer").classList = "col-md-9 col-12";
        }
        if (toggleLeftMenu) {
            document.getElementById("asideLeftContainer").classList =
                "col-md-3 col-12 d-flex flex-column";
            if (!document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.add("d-none");
            }
        } else {
            document.getElementById("asideLeftContainer").classList =
                "col-md-3 d-md-block col-12 d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
        if (toggleRightMenu) {
            document.getElementById("asideRightContainer").classList =
                "col-md-3 col-12 d-flex flex-column";
            document.getElementById("mainContainer").classList =
                "col-md-6 d-md-block col-12 d-none";
        } else {
            document.getElementById("asideRightContainer").classList = " d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
        if (toggleProfileMenu) {
            document.getElementById("asideProfileContainer").classList =
                "col-md-3 col-12 d-flex flex-column";
            document.getElementById("mainContainer").classList =
                "col-md-6 d-md-block col-12 d-none";
        } else {
            document.getElementById("asideProfileContainer").classList = "d-none";
            if (document.getElementById("mainContainer").classList.contains("d-none")) {
                document.getElementById("mainContainer").classList.remove("d-none");
                getHeights();
            }
        }
    }, [toggleLeftMenu, toggleRightMenu, toggleProfileMenu]);

    useEffect(() => {
        if (!showNewMessageLine)
            scrollToBottom();
        if (currentSearchResult) {
            // console.log("addMessage");
            // setTimeout(() => {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            for (let i = 0; i < 10; i++) {
                element.parentElement.scrollIntoView();
            }
            // }, 50);
        }
    }, [messages.length])

    useEffect(() => {
        if (!showNewMessageLine && isTyping.identity === participants.secondary.identity)
            getHeights();
    }, [isTyping.status])

    useEffect(() => {
        if (selectedConversation) {
            selectedConversation.getParticipants().then(participantList => {
                participantList.map(participant => {
                    participant.getUser().then(user => {
                        // console.log("participant", participant, "user", user);
                        if (participant.identity === primaryClient.user.identity) {
                            setParticipants(participants => ({ ...participants, primary: { lastReadMessageIndex: participant.lastReadMessageIndex, identity: participant.identity, friendlyName: participant.friendlyName, isOnline: user.isOnline, attributes: user.attributes } }));
                        } else {
                            if (user.attributes && notifications.newChatMessage.length > 0) {
                                for (let i = notifications.newChatMessage.length - 1; i >= 0; i--) {
                                    if (notifications.newChatMessage[i].description === user.attributes.email) {
                                        AuthService.markNotificationAsRead("ProviderChat", notifications.newChatMessage[i].id);
                                    }
                                }
                            }
                            setParticipants(participants => ({ ...participants, secondary: { identity: participant.identity, friendlyName: participant.friendlyName, isOnline: user.isOnline, attributes: user.attributes } }));
                        }
                        user.on('updated', (user) => {
                            // console.log("userUpdated");
                            setParticipants(participants => {
                                if (user.updateReasons.includes("reachabilityOnline") && user.user.identity === participants.secondary.identity) {
                                    return ({ ...participants, secondary: { ...participants.secondary, isOnline: user.user.isOnline } });
                                }
                                return participants;
                            })
                        })
                    })
                })
            })
            ProviderService.getConversationNote(`${providerId}_${selectedConversation.userDetails._id}`).then(data => {
                setConversationNotes(data.notes);
            });
            toggleSidebar();
        }
    }, [updateSelectedConversation]);

    useEffect(() => {
        if (search.status) {
            document.getElementById("searchInput").focus();
        }
    }, [search.status]);

    useEffect(() => {
        removeMark();
        if (search.value) {
            currentSearchPage = 0;
            searchResult = [];
            performSearch();
        }
    }, [search.value]);

    const loadEmojiKeyborad = () => {
        const picker = new EmojiButton();
        const trigger = document.querySelector('.trigger');
        picker.on('emoji', selection => {
            // `selection` object has an `emoji` property
            // containing the selected emoji
            onEmojiClick(null, selection);
        });
        trigger.addEventListener('click', () => picker.togglePicker(trigger));
    }

    const closeRightMenus = () => {
        document.getElementById("asideRightContainer").classList = "d-none";
        document.getElementById("asideProfileContainer").classList = "d-none";
        setToggleRightMenu(false);
        setToggleProfileMenu(false);
    };

    const toggle = () => setIsOpen(!isOpen);

    const getNotifications = () => {
        AuthService.getNotifications().then(data => {
            let temp = { newChatMessage: [] };
            Promise.all(data.notifications.ProviderChat.map(item => {
                if (!item.readStatus && item.title === "newChatMessage") {
                    temp.newChatMessage.push({ id: item._id, description: item.description });
                }
            })).then(() => {
                setNotifications(temp);
            })
        })
    }

    // useEffect(() => {
    //     console.log("primary", participants.primary.lastReadMessageIndex);
    // }, [participants]);

    const toggleSidebar = () => {
        // e.preventDefault();
        // document.getElementById("asideContainer").classList.toggle("openSideContainer");
        // document.getElementById("asideContainer").classList.toggle("closeSideContainer");
        // document.getElementById("mainContainer").classList.toggle("openMainContainer");
        // document.getElementById("mainContainer").classList.toggle("closeMainContainer");
        // getHeights();
    }

    const getHeights = () => {
        try {
            const mainHeight = document.getElementById("mainContainer").offsetHeight;
            const headerHeight = document.getElementById("header").offsetHeight;
            const typingDivHeight = document.getElementById("typingDiv") ? document.getElementById("typingDiv").offsetHeight : 0;
            const footerHeight = document.getElementById("footer").offsetHeight;
            const chatDivHeight = mainHeight - headerHeight - typingDivHeight - footerHeight;
            document.getElementById('chatDiv').setAttribute("style", `height: ${chatDivHeight}px`);
            document.getElementById('chatDiv').style.height = `${chatDivHeight}px`;
            scrollToBottom();
        } catch (err) { }
    }

    const handleChatScroll = (e) => {
        let chatList = e.target;
        const value = chatList.scrollHeight - chatList.scrollTop - chatList.clientHeight;
        if (!showNewMessageLine && value > 200) {
            setShowNewMessageLine(true)
        } else if (showNewMessageLine && value < 200) {
            setShowNewMessageLine(false)
        }
        if (!showChatScrollDown && value > 500) {
            setShowChatScrollDown(true)
        } else if (showChatScrollDown && value < 500) {
            setShowChatScrollDown(false)
        }
        // if (currentSearchResult) {
        //     let element = document.getElementById(`msg${currentSearchResult.index}`);
        //     element.parentElement.scrollIntoView();
        // }
        if (chatList.scrollTop < 50 && !isShowMoreLoading && !search.status && selectedConversationPage && selectedConversationPage.hasPrevPage) {
            const initialHeight = chatList.scrollHeight;
            loadOldChat("handleChatScroll").then(() => {
                chatList.scrollTop = chatList.scrollHeight - initialHeight;
            });
        }
    }

    function scrollToBottom() {
        try {
            let someElement = document.getElementById('chat');
            someElement.scrollTop = someElement.scrollHeight + document.getElementById('chat').lastChild.offsetHeight;
        } catch (err) { }
    }

    const onEmojiClick = (emojiObject) => {
        setMessage(message => message + emojiObject.emoji);
    }

    // const getSubscriptionDetails = () => {
    //     ClientService.getSubscription().then(subscription => {
    //         setSubscriptionDetail(subscription.data);
    //         console.log("subscription", subscription);
    //         ClientService.getClientProfileImage().then(clientDetails => {
    //             console.log("clientDetails", clientDetails);
    //             setUser({ ...user, profileImage: clientDetails.profileImage });
    //             ClientService.getChatProviderDetails().then(providerDetails => {
    //                 console.log("providerDetails", providerDetails);
    //                 setSelectedProvider(providerDetails.selectedProvider);
    //                 setListOfSessions(providerDetails.sessions);
    //                 getChatToken(`client_${clientDetails.id}`);
    //                 // getChatToken('QuietKendraUtica');
    //             }).catch(err => console.log("err", err));
    //         })
    //     })
    // }

    // get conversation list
    // 

    const getUser = () => {
        // ChatService.getConversation(user.email).then(conversations => {
        // conversations.conversations.map(item => {
        // item.participants.map(participant => {
        // if (user.email === participant.identity && user.selectedRole === "provider") {
        ProviderService.getProviderProfileImageAndEmail()
            .then(data => {
                providerId = data.id;
                // console.log('providerId', providerId);
                setUser({ ...user, profileImage: data.profileImage });
                // getChatToken(`provider_${data.id}`);
                // getChatToken("YawningMufasaJamestown");
            })
        // }
        // else if (user.email === "hingu.shalin@gmail.com" && participant.identity === "hingu.shalin@gmail.com") {
        //     getChatToken("QuietKendraUtica");
        // } 
        // })
        // })
        // })
    }

    const getChatToken = (identity) => {
        setStatusString("Fetching credentials…");
        ChatService.getChatToken(identity).then(data => {
            connectMessagingClient(data.token);
        })
    }

    const connectMessagingClient = (token) => {
        ConversationsClient.create(token).then(client => {
            setStatusString("Connecting to chat...");
            primaryClient = client;
            client.on('tokenAboutToExpire', () => {
                ChatService.getChatToken(client.user.identity).then(data => {
                    client.updateToken(data.token);
                })
            });
            client.on("connectionStateChanged", (state) => {
                if (state === "connecting") {
                    setStatusString("Connecting to chat...");
                    // console.log("Connecting to Twilio…");
                    // setStatus("default");
                }
                if (state === "connected") {
                    setStatusString("You are connected to chat.");
                    setConnectionLoading(false);
                    // console.log("You are connected");
                    // setStatus("success");
                }
                if (state === "disconnecting") {
                    setStatusString("Disconnecting from chat…");
                    // console.log("Disconnecting from Twilio…");
                    // setConversationsReady(false);
                    // setStatus("default");
                }
                if (state === "disconnected") {
                    setStatusString("Disconnected from chat.");
                    // console.log("Disconnected");
                    // setConversationsReady(false);
                    // setStatus("warning");
                }
                if (state === "denied") {
                    setStatusString("Failed to connect.");
                    // console.log("Failed to connect");
                    // setConversationsReady(false);
                    // setStatus("error");
                }
            });

            client.on("conversationJoined", (conversation) => {
                // console.log('conversationJoined');
                // setSelectedConversation(conversation);
                // subscribeConversationEvents(conversation);
                updateConversationList(conversation);
            });

            client.on("conversationLeft", (thisConversation) => {
                // console.log('conversationLeft');
                setConversations(conversations.filter((conversation) => conversation !== thisConversation));
            });
        })
    }

    const updateConversationList = (conversation) => {
        // if (conversation.uniqueName === "TestConversation2") {
        //     return;
        // }
        conversation.getParticipants().then(participants => {
            const list = participants.filter(participant => participant.identity !== primaryClient.user.identity);
            list[0].getUser().then(user => {
                // console.log('user', user.identity);
                ChatService.getClientProfile(user.identity).then(data => {
                    // console.log('data', data);
                    let isCalled = false;
                    setNotifications(notifications => {
                        if (!isCalled) {
                            isCalled = true;
                            Promise.all(notifications.newChatMessage.filter(item => item.description === user.state.attributes.email)).then(data2 => {
                                conversation.unreadMessages = data2.length;
                                conversation.secondaryUser = user.state;
                                conversation.userDetails = data;
                                // console.log("noti", notifications.newChatMessage, "data2", data2);
                                setConversations(conversations => [...conversations, conversation]);
                            })
                        }
                        return notifications;
                    });
                    // console.log("conversation", conversation);
                });
            })
        });
    }

    const subscribeConversationEvents = (currentChannel) => {
        currentChannel.on('updated', (conversation) => {
            // console.log('conversationUpdated');
            if (conversation.updateReasons.includes("lastMessage")) {
                let isCalled = false;
                setParticipants(participants => {
                    if (!isCalled) {
                        isCalled = true;
                        // console.log(participants);
                        if (!participants.secondary.isOnline) {
                            AuthService.addNotification(participants.secondary.attributes.email, "ClientChat", "General", "newChatMessage", participants.primary.attributes.email).then(() => {
                                // console.log("Notification added");
                            });
                        }
                    }
                    return participants;
                });
                setSelectedConversationMessageStatus(selectedConversationMessageStatus => ({ ...selectedConversationMessageStatus, lastMessage: conversation.conversation.lastMessage }));
            }
            // if (conversation.updateReasons.includes("lastReadMessageIndex")) {
            //     let temp = false;
            //     setShowNewMessageLine(showNewMessageLine => {
            //         temp = showNewMessageLine;
            //         return showNewMessageLine;
            //     });
            //     if (!temp) {
            //         setSelectedConversationMessageStatus(selectedConversationMessageStatus => ({ ...selectedConversationMessageStatus, lastReadMessageIndex: conversation.conversation.lastReadMessageIndex }));
            //     }
            // }
        })

        currentChannel.on('participantJoined', (participant) => {
            // console.log('participantJoined', participant);
            // addParticipant(participant);
        });

        currentChannel.on('participantLeft', (participant) => {
            // console.log('participantLeft', participant);
            // removeParticipant(participant);
        })

        currentChannel.on('participantUpdated', (participant) => {
            // console.log('participantUpdated');
            if (participant.updateReasons.includes("lastReadMessageIndex")) {
                let temp = false;
                setShowNewMessageLine(showNewMessageLine => {
                    temp = showNewMessageLine;
                    return showNewMessageLine;
                });
                if (!temp) {
                    setParticipants(participants => ({ ...participants, primary: { ...participants.primary, lastReadMessageIndex: participant.participant.lastReadMessageIndex } }));
                }
            }
        })

        currentChannel.on('messageAdded', (item) => {
            // console.log('messageAdded');
            let temp = false;
            setShowNewMessageLine(showNewMessageLine => {
                temp = showNewMessageLine;
                return showNewMessageLine;
            });
            if (!temp) {
                markMessageAsRead(item.index);
            }
            if (item.body === "ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=") {
                addMessage({ index: item.index, isCustomMessage: true, body: "Call session request sent" });
            } else if (item.body === "1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=") {
                addMessage({ index: item.index, isCustomMessage: true, body: "Video session request sent" });
            } else {
                addMessage(item);
            }
            if (item.author !== primaryClient.user.identity) {
                audio.play();
            }
        });

        currentChannel.on('typingStarted', (member) => {
            setIsTyping({ status: true, identity: member.identity });
        });

        currentChannel.on('typingEnded', (member) => {
            setIsTyping({ status: false, identity: '' });
        });

        getMessagesFromConversation(currentChannel);
    }

    const getMessagesFromConversation = (currentChannel) => {
        copyMessages = [];
        setMessages([]);
        // setSelectedConversationPage(null);
        selectedConversationPage = null;
        currentChannel.getMessages(pageSize).then(fetchedmessages => {
            // setSelectedConversationPage(fetchedmessages);
            selectedConversationPage = fetchedmessages;
            Promise.all(
                fetchedmessages.items.map(item => {
                    if (item.body === "ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=") {
                        addMessage({ index: item.index, isCustomMessage: true, body: "Call session request sent" });
                    } else if (item.body === "1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=") {
                        addMessage({ index: item.index, isCustomMessage: true, body: "Video session request sent" });
                    } else {
                        addMessage(item);
                    }
                    // setMessages(fetchedmessages.items);
                    // addMessage({ index: item.index, isCustomMessage: true, body: `${primaryClient.user.identity} has joined.` });
                })
            ).then(() => {
                getHeights();
            })
        });
    }

    const joinConversation = (conversation) => {
        setToggleLeftMenu(false);
        if (selectedConversation && selectedConversation.sid === conversation.sid) {
            return;
        } else {
            if (selectedConversation) {
                selectedConversation.removeAllListeners();
            }
            selectedConversationPage = null;
            copyMessages = [];
            currentSearchResult = null;
            currentSearchPage = 0;
            searchResult = [];
            setSearch({ status: false, value: "" });
            setSelectedConversation(conversation);
            // setSelectedConversationMessageStatus({ lastMessage: conversation.lastMessage, lastReadMessageIndex: conversation.lastReadMessageIndex });
            setSelectedConversationMessageStatus({ lastMessage: conversation.lastMessage });
            subscribeConversationEvents(conversation);
            setUpdateSelectedConversation(updateSelectedConversation => !updateSelectedConversation);
        }
    }

    const leaveConversation = () => {
        // console.log("leaving", primaryClient);
        if (primaryClient.user.identity) {
            primaryClient.shutdown().then(() => {
                setStatusString("");
                setConversations([]);
                setSelectedConversation(null);
                // setSelectedConversationPage(null);
                selectedConversationPage = null;
                searchResult = [];
                setUpdateSelectedConversation(updateSelectedConversation => !updateSelectedConversation);
                setIsTyping({ status: false, identity: "" });
                setMessage("");
                setMessages([]);
                copyMessages = [];
            });
        }
    }

    const addMessage = (item) => {
        setMessages(messages => [...messages, item]);
        copyMessages.push(item);
    }

    const markMessageAsRead = (index) => {
        let isCalled = false;
        setSelectedConversation(selectedConversation => {
            if (!isCalled) {
                isCalled = true;
                selectedConversation.updateLastReadMessageIndex(index)
                    .then(() => {
                        // console.log("marked as read", index);
                    });
            }
            return selectedConversation;
        });
    }

    const handleTyping = (e) => {
        if (e.keyCode === 13) {
            document.getElementById('sendButton').click();
        } else if (selectedConversation) {
            selectedConversation.typing();
        }
    }

    const sendPopupRequest = (type) => {
        if (type === 'call') {
            selectedConversation.sendMessage("ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=");
        } else if (type === 'video') {
            selectedConversation.sendMessage("1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=");
        }
        toggleSidebar();
    }

    const sendMessage = () => {
        if (selectedConversation && message !== '') {
            selectedConversation.sendMessage(message);
            setMessage('');
        }
    }

    const handleMessageDoubleClick = (e) => {
        doubleClickCounter += 1;
        // console.log('doubleClickCounter', doubleClickCounter);
        if (doubleClickCounter == 1) {
            const tempTarget = e.target;
            setTimeout(() => {
                if (doubleClickCounter == 1) {
                    // console.log("single_click_callback");
                } else {
                    // console.log("e", tempTarget);
                    if (!toggleRightMenu) {
                        setToggleRightMenu(true);
                    }
                    setNewNote({ messageId: tempTarget.id, content: tempTarget.innerText });
                }
                doubleClickCounter = 0;
            }, 300);
        }
    }

    const addNote = () => {
        ProviderService.addConversationNote(`${providerId}_${selectedConversation.userDetails._id}`, newNote.messageId, newNote.content).then(data => {
            setConversationNotes(data.notes);
            setNewNote({ messageId: "", content: "" });
        });
    }

    const loadOldChat = async (src) => {
        counter = counter + 1;
        // console.log("called from", src, counter);
        setIsShowMoreLoading(true);
        await selectedConversationPage.prevPage().then(page => {
            Promise.all(
                page.items.map(item => {
                    if (item.body === "ixe0BBjvIiwwoT7UNk5iVfNjfUJTTVup0IqGBuUTAgc=") {
                        return { index: item.index, isCustomMessage: true, body: "Call session request sent" };
                    } else if (item.body === "1QLPeeVffQQI21QS4Uw1krzeh4R6M2GuWGWD9eGbLhA=") {
                        return { index: item.index, isCustomMessage: true, body: "Video session request sent" };
                    } else {
                        return item;
                    }
                })
            ).then(newMessages => {
                // setSelectedConversationPage(page);
                selectedConversationPage = page;
                copyMessages = newMessages.concat(copyMessages);
                setMessages(messages => newMessages.concat(messages));
                setIsShowMoreLoading(false);
            });
        });
    }

    // search functions
    const handleSearch = (value) => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            setSearch({ ...search, value: value });
        }, 500);
    }

    const performSearch = async () => {
        // console.log("copyMessages.length", copyMessages.length, "currentSearchPage", currentSearchPage);
        let tempArray = [];
        let start = copyMessages.length - 1 - (pageSize * currentSearchPage);
        let end = 0;
        // console.log("start", start, "end", end);
        for (let i = start; i >= end; i--) {
            let position = copyMessages[i].body.toLowerCase().search(search.value.toLowerCase());
            if (position > -1)
                tempArray.push({ start: position, index: copyMessages[i].index });
        }
        searchResult.push(tempArray);
        // console.log("searchResult", searchResult);
        if (tempArray.length > 0) {
            if (searchResult.length !== 0) {
                currentSearchPage = searchResult.length - 1;
            }
            currentSearchResult = searchResult[currentSearchPage][0];
            await addMark();
        } else {
            if (!isShowMoreLoading && copyMessages.length > 0 && selectedConversationPage && selectedConversationPage.hasPrevPage) {
                await loadOldChat("performSearch").then(() => {
                    currentSearchPage = currentSearchPage + 1;
                    performSearch();
                });
            }
        }
    }

    const searchUpDown = async (direction) => {
        let arrayIndex = await searchResult[currentSearchPage].findIndex(item => item.index === currentSearchResult.index);
        // console.log("arrayIndex", arrayIndex);
        if (direction === "up") {
            if (searchResult[currentSearchPage].length > 0 && searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)].index < currentSearchResult.index) {
                await removeMark();
                currentSearchResult = searchResult[currentSearchPage][arrayIndex + 1];
                await addMark();
            } else {
                if (searchResult.length > (currentSearchPage + 1)) {
                    currentSearchPage = currentSearchPage + 1;
                    while (searchResult[currentSearchPage].length === 0) {
                        currentSearchPage = currentSearchPage + 1;
                    }
                    await removeMark();
                    currentSearchResult = searchResult[currentSearchPage][0];
                    await addMark();
                } else {
                    if (!isShowMoreLoading && copyMessages.length > 0 && selectedConversationPage && selectedConversationPage.hasPrevPage) {
                        await loadOldChat("searchUpDown").then(() => {
                            currentSearchPage = currentSearchPage + 1;
                            performSearch();
                        });
                    } else {
                        // console.log("The end up");
                    }
                }
            }
        } else if (direction === "down") {
            if (searchResult[currentSearchPage][0].index > currentSearchResult.index) {
                // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                await removeMark();
                currentSearchResult = searchResult[currentSearchPage][arrayIndex - 1];
                await addMark();
            } else if (currentSearchPage > 0) {
                // console.log("currentSearchPage", currentSearchPage, "searchResult", searchResult, "current", currentSearchResult);
                currentSearchPage = currentSearchPage - 1;
                while (searchResult[currentSearchPage].length === 0) {
                    currentSearchPage = currentSearchPage - 1;
                }
                await removeMark();
                currentSearchResult = searchResult[currentSearchPage][(searchResult[currentSearchPage].length - 1)];
                await addMark();
            } else {
                // console.log("The end down");
            }
        }
    }

    const addMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let re = new RegExp(search.value, "gi"); // search for all instances
            let newText = text.replace(re, `<mark>${text.substr(currentSearchResult.start, search.value.length)}</mark>`);
            element.innerHTML = newText;
            element.parentElement.scrollIntoView();
        }
    }

    const removeMark = async () => {
        if (currentSearchResult) {
            let element = document.getElementById(`msg${currentSearchResult.index}`);
            let text = element.innerText;
            let newText = text.replace("<mark>", "");
            newText = newText.replace("</mark>", "");
            element.innerHTML = newText;
        }
    }

    const clearSearch = () => {
        searchResult = [];
        setSearch({ ...search, value: "" });
        document.getElementById("searchInput").value = "";
    }

    // function's return
    return (
        true ?
            userApprovalStatus ?
                <div id="container" className="providerChatWindow row m-0">
                    <div id="asideLeftContainer" className="col-md-3 col-12 d-flex flex-column">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <h5 className="mt-2 ml-1">Conversations</h5>
                            {/* <img height="28px" width="auto" src={s1} alt="search" /> */}
                        </div>

                        <ul className="mt-3" id="conversationList">
                            {
                                conversations.map((item, index) => (
                                    <li key={`conversation${index}`} className={selectedConversation ? item.sid === selectedConversation.sid ? "active" : "" : ""} onClick={() => joinConversation(item)}>
                                        {/* <i className="fas fa-user user mr-3"></i> */}
                                        <img className="my-auto" height="32px" width="32px" src={item.userDetails.profileImage ? item.userDetails.profileImage : defaultProfile} alt="profileImage" />
                                        <div className='ml-3'>{`${item.userDetails.title} ${item.userDetails.firstName} ${item.userDetails.lastName}` || item.secondaryUser.identity || item.friendlyName || item.uniqueName || item.sid}{item.unreadMessages > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.danger }}>{item.unreadMessages}</Badge> : null}</div>
                                        {item.secondaryUser.online ? <i className="fas fa-circle fa-xs ml-3" style={{ color: "#00FF00" }}></i> : null}
                                    </li>
                                ))
                            }
                        </ul>
                    </div>

                    <div id="mainContainer" className="col-md-6 col-12">
                        {
                            selectedConversation ? [
                                <div id="header" className="d-flex align-items-center">
                                    {
                                        search.status ? [
                                            <Button key="1" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => { setSearch({ status: false, value: "" }); }}><i className="fas fa-arrow-left"></i></Button>,
                                            <InputGroup key="2" className="d-flex my-auto" style={{ width: "100%", marginRight: '15px', border: "1px solid #ced4da", borderRadius: "0.25rem" }}>
                                                <Input id="searchInput" type="text" style={{ border: "none" }} placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} />
                                                <button className="btn bg-transparent" style={{ color: colors.primary }} onClick={() => clearSearch()}><i className="fa fa-times"></i></button>
                                            </InputGroup>,
                                            <Button key="3" className="iconButton my-auto" style={{ marginRight: '15px', color: colors.primary }} onClick={() => searchUpDown("up")} ><i className="fas fa-chevron-up"></i></Button>,
                                            <Button key="4" className="iconButton my-auto" style={{ color: colors.primary }} onClick={() => searchUpDown("down")}><i className="fas fa-chevron-down"></i></Button>
                                        ] : [
                                            <i
                                                className="fas fa-chevron-left fa-lg back-icon mr-2"
                                                onClick={() => setToggleLeftMenu(true)}
                                            ></i>,
                                            <i
                                                style={{ fontSize: "2rem", color: "#384E73", cursor: "pointer" }}
                                                className="fas fa-user mr-2"
                                                onClick={() => {
                                                    setToggleProfileMenu(!toggleProfileMenu);
                                                    setToggleRightMenu(false);
                                                }}
                                            ></i>,
                                            <div
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setToggleProfileMenu(!toggleProfileMenu);
                                                    setToggleRightMenu(false);
                                                }}
                                            >
                                                <h2>{selectedConversation ? `${selectedConversation.userDetails.title} ${selectedConversation.userDetails.firstName} ${selectedConversation.userDetails.lastName}` || selectedConversation.secondaryUser.identity : null}</h2>
                                                <h3>{selectedConversation ? participants.secondary.isOnline ? "online" : "offline" : ""}</h3>
                                            </div>,
                                            <div key="3" className="actionBtnContainer iconButton my-auto ml-auto" style={{ color: colors.primary }} onClick={() => setSearch({ status: true, value: "" })}><i className="fas fa-search"></i></div>,
                                            selectedConversation.userDetails.clientSubscriptions.length ? [
                                                <div className="actionBtnContainer" onClick={() => sendPopupRequest("call")}>
                                                    <div className="actionBtn d-icon">
                                                        <i className="fas fa-phone-alt d-icon"></i>
                                                    </div>
                                                </div>,
                                                <div className="actionBtnContainer" onClick={() => sendPopupRequest("video")}>
                                                    <div className="actionBtn d-icon">
                                                        <i className="fas fa-video d-icon"></i>
                                                    </div>
                                                </div>
                                            ] : null,
                                            <div
                                                className="actionBtnContainer"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setToggleRightMenu(!toggleRightMenu);
                                                    setToggleProfileMenu(false);
                                                }}
                                            >
                                                <div className="actionBtn d-icon">
                                                    <i className="fas fa-edit"></i>
                                                </div>
                                            </div>,
                                            <input
                                                type="checkbox"
                                                id="nav-toggle"
                                                className="nav-toggle"
                                                onChange={() => setToggleTopMenu(!toggleTopMenu)}
                                            ></input>,
                                            <label for="nav-toggle" className="ml-auto navbar">
                                                {
                                                    toggleTopMenu ?
                                                        <i
                                                            className="fas fa-times navCls"
                                                            style={{ color: "white", zIndex: "300", fontSize: "24px" }}
                                                        ></i>
                                                        :
                                                        <i className="fas fa-bars" style={{ fontSize: "24px" }}></i>
                                                }
                                            </label>
                                        ]
                                    }
                                    <nav className={toggleTopMenu ? "" : "d-none"}>
                                        <ul>
                                            <div className="d-flex flex-row justify-content-between align-items-center menu">
                                                <h5>Menu</h5>
                                            </div>

                                            <div className="d-flex flex-row align-items-center disp" onClick={() => { setToggleTopMenu(false); setSearch({ status: true, value: "" }); }}>
                                                <div className="actionBtn">
                                                    <i className="fas fa-search"></i>
                                                </div>
                                                <li>Search</li>
                                            </div>

                                            {
                                                selectedConversation.userDetails.clientSubscriptions.length ? [
                                                    <div className="d-flex flex-row align-items-center disp" onClick={() => { setToggleTopMenu(false); sendPopupRequest("call"); }}>
                                                        <div className="actionBtn">
                                                            <i className="fas fa-phone-alt my-auto"></i>
                                                        </div>
                                                        <li>Request a voice call</li>
                                                    </div>,
                                                    <div className="d-flex flex-row align-items-center disp" onClick={() => { setToggleTopMenu(false); sendPopupRequest("video"); }}>
                                                        <div className="actionBtn">
                                                            <i className="fas fa-video"></i>
                                                        </div>
                                                        <li>Request a video call</li>
                                                    </div>
                                                ] : null
                                            }

                                            <div
                                                className="d-flex flex-row align-items-center disp"
                                                onClick={() => {
                                                    setToggleRightMenu(!toggleRightMenu);
                                                    setToggleProfileMenu(false);
                                                    setToggleTopMenu(false);
                                                }}
                                            >
                                                <div className="actionBtn" style={{ cursor: "pointer" }}>
                                                    <i className="fas fa-edit"></i>
                                                </div>
                                                <li>Notes</li>
                                            </div>
                                        </ul>
                                    </nav>
                                </div>,
                                <div id="chatDiv" style={{ height: "400px" }}>
                                    <ul id="chat" onScroll={(e) => handleChatScroll(e)}>
                                        {
                                            messages.length === 0 ?
                                                <div className="d-flex h-100"><h5 className="m-auto">Seems like the conversation is empty. Send your first message by typing below.</h5></div>
                                                :
                                                messages.map((item, index) => ([
                                                    item.isCustomMessage ?
                                                        <li key={`message${index}`} style={{ textAlign: 'center' }}>
                                                            <h2 id={`msg${item.index}`} style={{ fontWeight: '600', fontSize: '1rem' }}>{item.body}</h2>
                                                        </li>
                                                        :
                                                        item.author === primaryClient.user.identity ?
                                                            <li key={`message${index}`} className="me">
                                                                <div className="entete">
                                                                    <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                                </div>
                                                                <div id={`msg${item.index}`} className="message" onClick={handleMessageDoubleClick}>
                                                                    {item.body}
                                                                </div>
                                                            </li>
                                                            :
                                                            <li key={`message${index}`} className="you">
                                                                <div className="entete">
                                                                    <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                                </div>
                                                                <div id={`msg${item.index}`} className="message" onClick={handleMessageDoubleClick}>
                                                                    {item.body}
                                                                </div>
                                                            </li>,
                                                    participants.primary.lastReadMessageIndex && (selectedConversationMessageStatus.lastMessage.index !== participants.primary.lastReadMessageIndex) && (item.index === participants.primary.lastReadMessageIndex) ?
                                                        <li key="newMsg" style={{ textAlign: 'center', padding: '0', borderBottom: '3px solid #ff0000' }}>
                                                            <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{selectedConversationMessageStatus.lastMessage.index - item.index} unread message{selectedConversationMessageStatus.lastMessage.index - item.index === 1 ? "" : "s"}</h2>
                                                        </li>
                                                        :
                                                        null
                                                ]))
                                        }
                                        {
                                            isTyping.status && isTyping.identity === participants.secondary.identity ?
                                                <li className="you">
                                                    <div className="message typing-indicator">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                </li>
                                                : null
                                        }
                                    </ul>
                                    {
                                        showChatScrollDown ?
                                            <div className="downArrowDiv" onClick={() => scrollToBottom()}>
                                                <span><i className="fas fa-angle-double-down"></i></span>
                                                {
                                                    selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex ?
                                                        <span className="badge">{selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex}</span>
                                                        : null
                                                }
                                            </div> : null
                                    }
                                </div>,
                                <div id="footer" className="d-flex">
                                    {
                                        selectedConversation && selectedConversation.userDetails.clientSubscriptions.length ?
                                            [
                                                <div style={{ position: "relative" }}>
                                                    <Button
                                                        className="iconButton trigger"
                                                        style={{ marginRight: "15px" }}
                                                        onLoad={loadEmojiKeyborad}
                                                    >
                                                        <i className="far fa-smile"></i>
                                                    </Button>
                                                </div>,
                                                <Input
                                                    style={{ marginRight: "15px", border: "none" }}
                                                    placeholder="Type your message"
                                                    value={message}
                                                    onKeyDown={(e) => handleTyping(e)}
                                                    onChange={(e) => setMessage(e.target.value)}
                                                ></Input>,
                                                <Button
                                                    id="sendButton"
                                                    className="iconButton d-flex flex-row justify-content-center align-items-center"
                                                    onClick={() => sendMessage()}
                                                >
                                                    <p
                                                        className="ml-2 mr-3 mt-3"
                                                        style={{ color: "white", fontSize: "1rem" }}
                                                    >
                                                        Send
                                                    </p>
                                                    <img height="16px" width="auto" src={send} />
                                                </Button>
                                            ]
                                            :
                                            <div className="w-100 text-center">You cannot send message as user does not have any active subscription plan</div>
                                    }
                                </div>
                            ]
                                :
                                <div className="d-flex h-100">
                                    <h3 className="m-auto text-center" style={{ fontSize: "1.75rem" }}>Select a conversation to start</h3>
                                </div>
                        }
                    </div>

                    {/* Notes */}

                    <div id="asideRightContainer" className="d-none">
                        <div className="d-flex flex-row align-items-center my-3 pb-2">
                            {toggleRightMenu ? (
                                <h4 className="backBtn mb-0" onClick={() => closeRightMenus()}>
                                    <i
                                        className="fas fa-chevron-left"
                                        style={{ color: "#384E73", cursor: "pointer" }}
                                    ></i>
                                </h4>
                            ) : null}

                            <img className="ml-2" src={note} height="26px" width="26px" />
                            <h5 className="mb-0 ml-1">Notes</h5>
                        </div>

                        {
                            conversationNotes.map((item, index) => (
                                <p key={index}>
                                    <i className="fas fa-circle mr-2" style={{ fontSize: "0.6rem", color: "#48484b" }}></i>
                                    {item.content}
                                </p>

                            ))
                        }
                        <p className="mt-3">
                            <Input type="text" placeholder="Type here and click on +" value={newNote.content} onChange={(e) => setNewNote({ messageId: '', content: e.target.value })} />
                        </p>
                        <div className="w-100 text-center">
                            <div className="mx-auto"
                                style={{
                                    cursor: "pointer",
                                    width: "40px",
                                    height: "40px",
                                    fontSize: "2rem",
                                    borderRadius: "50%",
                                    background: colors.primary,
                                    lineHeight: "34px",
                                    color: "white"
                                }}
                                onClick={addNote}
                            >+</div>
                        </div>
                        <div className="d-flex flex-column justify-content-center align-items-center my-auto tip">
                            <i className="fas fa-lightbulb"> Tip</i>
                            <p className="mt-1 text-center">
                                Double press on message to add it<br />to the notes
                            </p>
                        </div>
                    </div>

                    {/* CLient Profile */}
                    <div id="asideProfileContainer" className="d-none">
                        {
                            selectedConversation ? [
                                <div className="d-flex flex-row mt-3 align-items-center">
                                    {toggleProfileMenu ? (
                                        <h4 className="backBtn" onClick={() => closeRightMenus()}>
                                            <i
                                                className="fas fa-chevron-left mx-2"
                                                style={{ cursor: "pointer" }}
                                            ></i>
                                        </h4>
                                    ) : null}
                                    <h5 className="ml-2">Client Profile</h5>
                                </div>,

                                <div className="my-4 mx-auto">
                                    <i
                                        style={{ fontSize: "3rem", margin: "1rem" }}
                                        className="fas fa-user icon"
                                    ></i>
                                </div>,

                                <div className="ml-2 d-flex align-items-center">
                                    <i
                                        className="fas fa-user icon mr-3"
                                        style={{ fontSize: "1.4rem" }}
                                    ></i>
                                    <div>
                                        <h6 className="mb-0">Name</h6>
                                        {`${selectedConversation.userDetails.title} ${selectedConversation.userDetails.firstName} ${selectedConversation.userDetails.lastName}` || participants.secondary.identity || participants.secondary.friendlyName}
                                    </div>
                                </div>,

                                <div className="mt-2 ml-2 d-flex align-items-center">
                                    <i
                                        className="fas fa-map-marker-alt icon mr-3"
                                        style={{ fontSize: "1.4rem" }}
                                    ></i>
                                    <div>
                                        <h6 className="mb-0">Location and Time</h6>
                                        {`${selectedConversation.userDetails.city}, ${selectedConversation.userDetails.state} ${selectedConversation.userDetails.country}`}
                                        {/* Surat, Gujarat, India | 12:00 PM */}
                                    </div>
                                </div>,

                                // {/* Other details */ }
                                <div className="mt-4 ml-2" >
                                    <button
                                        type="button"
                                        onClick={toggle}
                                        className="pd-1 d-flex align-items-center justify-content-between px-0 m-display"
                                    >
                                        Other Details
                                        {isOpen ? (
                                            <i
                                                className="fas fa-angle-up
         icon"
                                                style={{ fontSize: "1.4rem" }}
                                            ></i>
                                        ) : (
                                            <i
                                                className="fas fa-angle-right
         icon"
                                                style={{ fontSize: "1.4rem", color: "#232325" }}
                                            ></i>
                                        )}
                                    </button>

                                    <Collapse isOpen={isOpen}>
                                        <div className="mt-3 ml-1 d-flex align-items-center">
                                            <i
                                                className="fas fa-envelope icon mr-3"
                                                style={{ fontSize: "1.3rem" }}
                                            ></i>
                                            <div>
                                                <h6 className="mb-0">Email</h6>
                                                {selectedConversation.userDetails.email}
                                                {/* joe@gmail.com */}
                                            </div>
                                        </div>

                                        <div className="mt-3 ml-1 d-flex align-items-center">
                                            <i
                                                className="fas fa-phone-alt icon mr-3"
                                                style={{ fontSize: "1.3rem" }}
                                            ></i>
                                            <div>
                                                <h6 className="mb-0">Mobile no</h6>
                                                {selectedConversation.userDetails.phone}
                                                {/* 9876543210 */}
                                            </div>
                                        </div>

                                        <div className="mt-3 ml-1 d-flex align-items-center">
                                            <i
                                                className="fas fa-tag fa-flip-horizontal icon mr-3"
                                                style={{ fontSize: "1.3rem" }}
                                            ></i>
                                            <div>
                                                <h6 className="mb-0">Subscription plan</h6>
                                                {selectedConversation.userDetails.clientSubscriptions.length ? selectedConversation.userDetails.clientSubscriptions[0].clientSubscriptionPlan.name : 'No active plan'}
                                                {/* Starter Pack */}
                                            </div>
                                        </div>
                                    </Collapse>
                                </div>
                            ] :
                                null
                        }
                    </div>
                </div >
                :
                <UserNotApproved />
            :
            <div id="container" className="chatWindow row m-0">
                {connectionLoading ? <div id="overlay"><div className="h-100 d-flex"><h3 className="m-auto text-center">{statusString}</h3></div></div> : null}
                <div id="asideContainer" className="col-md-3 col-12 d-flex flex-column closeSideContainer">
                    <h4 className="backBtn" style={{ marginBottom: "15px" }} onClick={() => toggleSidebar()}><i className="fas fa-arrow-left"></i></h4>
                    <h4 style={{ color: '#ffffff', borderBottom: "2px solid #ffffff" }}>Conversations</h4>
                    <ul id="conversationList">
                        {
                            conversations.map((item, index) => (
                                <li key={`conversation${index}`} className={selectedConversation ? item.sid === selectedConversation.sid ? "selectedConversationLi" : "conversationLi" : "conversationLi"} onClick={() => joinConversation(item)}>
                                    <div>
                                        <h2>{item.secondaryUser.identity || item.friendlyName || item.uniqueName || item.sid}{item.unreadMessages > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.danger }}>{item.unreadMessages}</Badge> : null}</h2>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                    {/* {
                        selectedConversation ? [
                            <h4 className="mt-4" style={{ color: '#ffffff', borderBottom: "2px solid #ffffff" }}>Participants</h4>,
                            <ul id="userList">
                                {
                                    participants.map((item, index) => (
                                        <li key={`participant${index}`}>
                                            <div className="d-flex">
                                                <h2>{item.identity}{item.identity === primaryClient.user.identity ? ' (You)' : ''}</h2><div className={`status ml-auto my-auto ${item.isOnline ? "green" : "orange"}`}></div>
                                            </div>
                                        </li>
                                    ))
                                }
                            </ul>
                        ] : null
                    } */}
                    <div className="mt-auto">
                        <Button className="w-100" onClick={() => sendPopupRequest("call")}>Send call request</Button>
                        <Button className="w-100 mt-2" onClick={() => sendPopupRequest("video")}>Send video request</Button>
                    </div>
                </div>
                <div id="mainContainer" className="col-md-9 col-12 openMainContainer">
                    <div id="header" className="d-flex">
                        {
                            search.status ? [
                                <Button key="headerBtn1" className="iconButton my-auto" style={{ marginRight: '15px' }} onClick={() => setSearch({ status: false, value: "" })}><i className="fas fa-arrow-left"></i></Button>,
                                <InputGroup className="d-flex my-auto" style={{ width: "100%", marginRight: '15px', border: "1px solid #ced4da", borderRadius: "0.25rem" }}>
                                    <Input id="searchInput" type="text" style={{ border: "none" }} placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} />
                                    <button className="btn bg-transparent" onClick={() => clearSearch()}><i className="fa fa-times"></i></button>
                                </InputGroup>,
                                <Button key="headerBtn2" className="iconButton my-auto" style={{ marginRight: '15px' }} onClick={() => searchUpDown("up")} ><i className="fas fa-chevron-up"></i></Button>,
                                <Button key="headerBtn3" className="iconButton my-auto" onClick={() => searchUpDown("down")}><i className="fas fa-chevron-down"></i></Button>
                            ] : [
                                <img className="my-auto" height="55px" width="55px" src={selectedConversation ? selectedConversation.profileImage ? selectedConversation.profileImage : defaultProfile : defaultProfile} alt="profileImage" onClick={() => toggleSidebar()} />,
                                <div className="my-auto">
                                    <h2>{participants.secondary.identity || participants.secondary.friendlyName}</h2>
                                    <h3>{selectedConversation ? participants.secondary.isOnline ? "online" : "offline" : ""}</h3>
                                </div>,
                                selectedConversation ? [
                                    <Button key="headerBtn1" className="iconButton my-auto ml-auto" style={{ marginRight: '15px' }} onClick={() => setSearch({ status: true, value: "" })}><i className="fas fa-search"></i></Button>,
                                    <Button key="headerBtn2" className="iconButton my-auto" onClick={() => props.history.push('sessions')}><i className="fas fa-sign-out-alt"></i></Button>
                                ]
                                    :
                                    null
                            ]
                        }
                    </div>
                    <div id="chatDiv">
                        {
                            isShowMoreLoading ?
                                <div style={{ textAlign: 'center' }}>
                                    <span className="spinner-border spinner-border-sm"></span>
                                </div>
                                : null
                        }
                        <ul id="chat" onScroll={(e) => handleChatScroll(e)}>
                            {
                                selectedConversation ?
                                    messages.map((item, index) => ([
                                        item.isCustomMessage ?
                                            <li key={`message${index}`} style={{ textAlign: 'center' }}>
                                                <h2 id={`msg${item.index}`} style={{ fontWeight: '600', fontSize: '1rem' }}>{item.body}</h2>
                                            </li>
                                            :
                                            item.author === primaryClient.user.identity ?
                                                <li key={`message${index}`} className="me">
                                                    <div className="entete">
                                                        <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                    </div>
                                                    <div id={`msg${item.index}`} className="message">
                                                        {item.body}
                                                    </div>
                                                </li>
                                                :
                                                <li key={`message${index}`} className="you">
                                                    <div className="entete">
                                                        <h3>{moment(item.dateCreated).format('DD-MM-YYYY hh:mm A')}</h3>
                                                    </div>
                                                    <div id={`msg${item.index}`} className="message">
                                                        {item.body}
                                                    </div>
                                                </li>,
                                        participants.primary.lastReadMessageIndex && (selectedConversationMessageStatus.lastMessage.index !== participants.primary.lastReadMessageIndex) && (item.index === participants.primary.lastReadMessageIndex) ?
                                            <li key="newMsg" style={{ textAlign: 'center', padding: '0', borderBottom: '3px solid #ff0000' }}>
                                                <h2 style={{ fontWeight: '600', fontSize: '1rem' }}>{selectedConversationMessageStatus.lastMessage.index - item.index} unread message{selectedConversationMessageStatus.lastMessage.index - item.index === 1 ? "" : "s"}</h2>
                                            </li>
                                            :
                                            null
                                    ]))
                                    :
                                    <div className="d-flex h-100">
                                        <h3 className="m-auto text-center" style={{ fontSize: "1.75rem" }}>Select a conversation to start</h3>
                                    </div>
                            }
                            {
                                isTyping.status && isTyping.identity === participants.secondary.identity ?
                                    <li className="you">
                                        <div className="message typing-indicator">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </li>
                                    : null
                            }
                        </ul>
                        {
                            showChatScrollDown ?
                                <div className="downArrowDiv" onClick={() => scrollToBottom()}>
                                    <span><i className="fas fa-angle-double-down"></i></span>
                                    {
                                        selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex ?
                                            <span className="badge">{selectedConversationMessageStatus.lastMessage.index - participants.primary.lastReadMessageIndex}</span>
                                            : null
                                    }
                                </div> : null
                        }
                    </div>
                    <div id="footer" className="d-flex">
                        <div style={{ position: "relative" }}>
                            <Button className="iconButton trigger" style={{ marginRight: '15px' }}><i className="fas fa-laugh"></i></Button>
                        </div>
                        <Input style={{ marginRight: '15px' }} placeholder="Type your message" value={message} onChange={(e) => setMessage(e.target.value)} onKeyDown={(e) => handleTyping(e)}></Input>
                        <Button id="sendButton" className="iconButton" onClick={sendMessage}><i className="far fa-paper-plane"></i></Button>
                    </div>
                </div>
            </div>
    )
}

export default ProviderChat;